const s = {
  name: "PosGood",
  dimensions: { width: 22, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 40" style="enable-background:new 0 0 22 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,22.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,20.3,5.8,21C5.8,21.7,6.3,22.3,7,22.3z"/>
		<path class="st0" d="M12.3,21c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,19.8,12.3,20.3,12.3,21z"
			/>
		<path class="st0" d="M15,22.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,21.7,14.3,22.3,15,22.3z"
			/>
		<path class="st0" d="M8.3,25c0,0.7-0.6,1.2-1.2,1.2S5.8,25.7,5.8,25c0-0.7,0.6-1.2,1.2-1.2S8.3,24.3,8.3,25z"/>
		<path class="st0" d="M11,26.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C9.8,25.7,10.3,26.3,11,26.3z"
			/>
		<path class="st0" d="M16.3,25c0,0.7-0.6,1.2-1.3,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,23.8,16.3,24.3,16.3,25z"
			/>
		<path class="st0" d="M7,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2S5.8,28.3,5.8,29C5.8,29.7,6.3,30.3,7,30.3z"/>
		<path class="st0" d="M12.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C11.7,27.8,12.3,28.3,12.3,29z"
			/>
		<path class="st0" d="M15,30.3c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C13.8,29.7,14.3,30.3,15,30.3z"
			/>
		<path class="st0" d="M10,12.4l5.7-5.7l-1.4-1.4L10,9.6L7.7,7.3L6.3,8.7L10,12.4z"/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h16c1.7,0,3,1.3,3,3v29c0,1.7-1.3,3-3,3v2c0,1.7-1.3,3-3,3H6c-1.7,0-3-1.3-3-3v-2
			c-1.7,0-3-1.3-3-3V3z M5,37c0,0.5,0.5,1,1,1h10c0.5,0,1-0.5,1-1v-2H5V37z M3,33h16c0.5,0,1-0.5,1-1V17H2v15C2,32.5,2.5,33,3,33z
			 M20,15V3c0-0.5-0.5-1-1-1H3C2.5,2,2,2.5,2,3v12H20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosGood
};
